function initHorizontalCarousel(root) {
    if (!root) return;
    if (root.dataset.hcarInitialized === 'true') return;
    if (typeof EmblaCarousel !== 'function') return;

    const viewport = root.querySelector('[data-hcar-viewport]');
    if (!viewport) return;

    const plugins = [];
    if (typeof EmblaCarouselWheelGestures === 'function') {
        plugins.push(
            EmblaCarouselWheelGestures({
                forceWheelAxis: 'x',
                target: viewport,
            })
        );
    }

    const embla = EmblaCarousel(viewport, { align: 'start' }, plugins);
    root.dataset.hcarInitialized = 'true';

    const progressBar = root.querySelector('.hcar__progressBar');

    const updateProgress = () => {
        if (!progressBar) return;
        const progress = Math.max(0, Math.min(1, embla.scrollProgress()));
        progressBar.style.transform = `scaleX(${progress})`;
    };

    embla.on('reInit', updateProgress);
    embla.on('scroll', updateProgress);
    updateProgress();

    const rootId = root.dataset.hcarRoot;
    const scope = root.closest(`[data-hcar-scope="${rootId}"]`) || document;

    const prevBtns = scope.querySelectorAll('[data-hcar-prev]');
    const nextBtns = scope.querySelectorAll('[data-hcar-next]');

    prevBtns.forEach((btn) => {
        btn.addEventListener('click', () => embla.scrollPrev());
    });

    nextBtns.forEach((btn) => {
        btn.addEventListener('click', () => embla.scrollNext());
    });

    window.addEventListener(
        'load',
        () => {
            embla.reInit();
        },
        { once: true }
    );
}

function initAllHorizontalCarousels(scope = document) {
    const carousels = scope.querySelectorAll('.embla[data-hcar-root]');
    carousels.forEach(initHorizontalCarousel);
}

document.addEventListener('DOMContentLoaded', () => {
    initAllHorizontalCarousels();
});